export default __webpack_public_path__ + "static/media/PearlLovelace.83dc5c64.png";